// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// A vertical airflow run — dashed line plus an arrow head at the far end.
// Supply blows down-plan out of the top CRAH lineup, return draws up-plan to
// the bottom one, so the head direction falls out of y1 → y2.

import React from 'react';
import type { PlanAirflow } from '../../../types/floorPlan';

const HEAD = 4;

export default function PlanAirflowRun({ run }: { run: PlanAirflow }) {
  const down = run.y2 > run.y1;
  const tip = run.y2;
  const base = down ? tip - HEAD : tip + HEAD;

  return (
    <g className={`plan-flow plan-flow-${run.kind}`} data-testid={`plan-flow-${run.id}`}>
      <line x1={run.x} y1={run.y1} x2={run.x} y2={base} className="plan-flow-line" />
      <polygon
        points={`${run.x},${tip} ${run.x - HEAD / 1.6},${base} ${run.x + HEAD / 1.6},${base}`}
        className="plan-flow-head"
      />
    </g>
  );
}
